// src/pages/fiscal/mdfe/CondutorSearch.js
import React from 'react';
import CadastroFiscalSearch from './CadastroFiscalSearch';

const CondutorSearch = ({ show, onHide, onSelectCondutor, registros = [] }) => (
  <CadastroFiscalSearch show={show} onHide={onHide} titulo="Buscar Condutor" registros={registros}
    campos={['nome', 'cpf']} onSelect={onSelectCondutor} />
);
export default CondutorSearch;
